import { message } from 'antd';

export const popIn = (type, body, duration = 5, options = {}) => {
	message.config({ top: 50, ...options });
	return message[type](body, duration);
};
